import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function PasswordSection({

  form,

  handleChange,

  createAccount,

  loading,

  buttonText = "Create Account"

}) {

  const [showPassword, setShowPassword] = useState(false);

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (

    <>

      {/* Password */}

      <div className="input-group password-group">

        <input

          type={showPassword ? "text" : "password"}

          name="password"

          value={form.password}

          onChange={handleChange}

          placeholder=" "

          required

        />

        <label>Create Password</label>

        <span

          className="eye-icon"

          onClick={() =>

            setShowPassword(!showPassword)

          }

        >

          {showPassword ? (

            <FaEyeSlash />

          ) : (

            <FaEye />

          )}

        </span>

      </div>

      {/* Confirm Password */}

      <div className="input-group password-group">

        <input

          type={showConfirmPassword ? "text" : "password"}

          name="confirmPassword"

          value={form.confirmPassword}

          onChange={handleChange}

          placeholder=" "

          required

        />

        <label>Confirm Password</label>

        <span

          className="eye-icon"

          onClick={() =>

            setShowConfirmPassword(

              !showConfirmPassword

            )

          }

        >

          {showConfirmPassword ? (

            <FaEyeSlash />

          ) : (

            <FaEye />

          )}

        </span>

      </div>

      {/* Create Account */}

     <button
  onClick={createAccount}
  disabled={loading}
>
  {loading
    ? "Please wait..."
    : buttonText}
</button>

    </>

  );

}

export default PasswordSection;